
















































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ChangeFlightDayModal from "./changeFlightDayModal.vue";
import CancelFlightOrderModal from "./cancelFlightOrderModal.vue";
import PassengerEditModal from "./passengerEditModal.vue";
import RemovePassengerModal from "./removePassengerModal.vue";
import ServiceLogsPanel from "@/views/pages/logs/ServiceLogsPanel.vue";
import FlightReservationOrder from "@/store/entities/flight/reservation/flightReservationOrder";
import ReservationList from "@/store/entities/flight/reservation/reservationList";
import PassengerInherit from "@/store/entities/passangerInherit";
import CancelOrder from "@/store/entities/flight/reservation/cancelOrder";
import ApproveOrderById from "@/store/entities/flight/reservation/approveOrderById";
import Customer from "@/store/entities/customer";
import ajax from "@/lib/ajax";
import util from "@/lib/util";
import Refund from "@/store/entities/refund";
import Currency from "@/store/entities/currency";
@Component({
  components: {
    ChangeFlightDayModal,
    CancelFlightOrderModal,
    PassengerEditModal,
    RemovePassengerModal,
    ServiceLogsPanel,
  },
})
export default class ReservationDetailModal extends Vue {
  radios: boolean = true;
  dialog: boolean = true;
  dialogAgree: boolean = false;
  dialogRevert: boolean = false;
  PassengerCancelModal: boolean = false;
  dialogRefund: boolean = false;
  PassengerRefundModal: boolean = false;
  dialogAmount: boolean = false;
  dialogChangeCurrency: boolean = false;
  dialogEmail: boolean = false;
  dialogConfirm: boolean = false;
  dialogCreateReservation: boolean = false;
  isOpenServiceLogs: boolean = false;
  mockData: any[] = [];
  headersEmailMessage: any[] = [];
  headers: any[] = [];
  mockDataOperatorHistory: any[] = [];
  headersOperatorHistory: any[] = [];
  mockDataFlightOrder: any[] = [];
  headersFlightOrder: any[] = [];
  active_tab: number = 0;
  isOpenRow: boolean = false;
  isOpenFlightOrder: boolean = true;
  mockDataPassangers: any[] = [];
  headersPassangers: any[] = [];
  isOpenModal: boolean = false;
  isOpenCancelFlightOrderModal: boolean = false;
  isOpenPassengerEditModal: boolean = false;
  isOpenRemovePassengerModal: boolean = false;
  reservationList: FlightReservationOrder[] = [];
  flightOrders: FlightReservationOrder[] = [];
  passengers: PassengerInherit[] = [];
  flightNo: string;
  radioGroup: number | string = 1;
  cancelOrder: CancelOrder = new CancelOrder();
  orderId: string = "";
  dialogSalesEmail:boolean=false;
  emailMessages:any[]=[];
  additionalPayments:any[]=[];
  currencyId:string;
  pdfLink:string="";
  isOpenEmailList: boolean = false;
  isOpenAddList:boolean=false;
  refundTotal:number=0;
  extraTotal:number=0;
  headersAdditionalPayments: any[] = [];
  currencies: Currency[] = [];
  currency:Currency=new Currency();
  amount:number=0;
  selectedPassengers:any[]=[];
  isFinanceUser:boolean=false;

  confirmCreateReservation() {
    // Onay diyaloğunu kapat
    this.dialogCreateReservation = false;
    // Rezervasyon oluşturma işlemini başlat
    this.createReservation();
  }

  async createReservation() {
    try {
      this.$store.dispatch('loading/show', { text: 'Rezervasyon oluşturuluyor...' });
      
      // ID'yi doğrudan parametre olarak gönderiyoruz
      const reservationId = this.reservationList[0].orderId;
      const response = await ajax.post(`/api/services/app/booking/CreateIatiReservation?input=${reservationId}`);
      
      if (response.data.success) {
        this.$store.dispatch('snackbar/success', 'Rezervasyon başarıyla oluşturuldu');
        // Rezervasyon oluşturulduktan sonra sayfayı yenileyelim
        this.getReservation();
      } else {
        this.$store.dispatch('snackbar/error', response.data.error || 'Rezervasyon oluşturulurken bir hata oluştu');
      }
    } catch (error) {
      console.error('Rezervasyon oluşturma hatası:', error);
      this.$store.dispatch('snackbar/error', 'Rezervasyon oluşturulurken bir hata oluştu');
    } finally {
      this.$store.dispatch('loading/hide');
    }
  }
  
  get serviceLogsInitialDate() {
    if (!this.reservationList.length) {
      return null;
    }
    const creationTime = this.reservationList[0].creationTime;
    if (!creationTime) {
      return null;
    }
    return new Date(creationTime).toISOString().substring(0, 10);
  }

  get totalPrice(){
    if(this.reservationList.length>1){
      return this.reservationList[0].totalPrice +  this.reservationList[1].totalPrice 
    }
    return this.reservationList[0].totalPrice
    
  }

  

  async getCurrencies() {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });

    this.currencies = this.$store.state.currency.list;
  }

  async checkFinanceUser() {
    let rep = await ajax.get('/api/services/app/Session/GetCurrentLoginInformations', {
      headers: {
        'Abp.TenantId': util.abp.multiTenancy.getTenantIdCookie()
      }
    });
    const email = rep.data.result.user.emailAddress ? rep.data.result.user.emailAddress.toLowerCase() : '';
    if (email == "accounting@charterscanners.com" || email == "battal@charterscanners.com") {
      this.isFinanceUser = true;
    }
  }
 async getOrderDetail(id){
  await this.$store.dispatch({
      type: "reservation/getFlightOrders",
      data: id,
    });
  await this.getReservation();
 }
 async getReservation(){
  this.reservationList = this.$store.state.reservation.reservationDetail;
   
    this.orderId=this.reservationList[0].orderId; 
    this.currencyId=this.reservationList[0].currencyId;

    if(this.reservationList[0].emailMessages.length>0){
      this.emailMessages=this.reservationList[0].emailMessages;
    }
    if(this.reservationList[0].order.additionalPayments.length>0){
      this.additionalPayments=this.reservationList[0].order.additionalPayments;
    }
 }
  async created() {
    this.getCurrencies();
    this.getReservation();
    this.checkFinanceUser();

   
    
    if(this.reservationList[0].order.orderStatus == 4){
        this.pdfUrl();
    }

    (this.headersEmailMessage = [
      { text: "Kime", value: "emailTo" },
      { text: "Okundu", value: "isOpened" },
      { text: "Gönderildi", value: "isSent" },
      { text: "Spam", value: "isSpamReported" },
      { text: "Açılma Zamanı", value: "openedTime" },
      { text: "Gönderilme Zamanı", value: "sentTime" },
      { text: "Konu", value: "subject" },
    ]),

    (this.headersAdditionalPayments = [
      { text: "Ödeme Türü", value: "paymentRule" },
      { text: "Total", value: "total" },

    ]),


    
    (this.headers = [
      { text: "", value: "" },
      { text: "Ödeme Türü", value: "paymentType" },
      { text: "Ödeme Durumu", value: "paymentStatus" },
      { text: "Fiyat", value: "price" },
      { text: "Para Birimi", value: "currency" },
      { text: "Oluşturulma Tarihi", value: "creationDate" },
    ]),

      (this.headersOperatorHistory = [
        { text: "operator", value: "operator" },
        { text: "isAssigned", value: "isAssigned" },
        { text: "Operatör Durumu", value: "operatorStatus" },
        { text: "Not", value: "isNote" },
        { text: "Oluşturulma Tarihi", value: "creationDate" },
      ]),
      (this.headersFlightOrder = [
        { text: '', value: 'icon', sortable: false, width: '50px' },
        { text: 'PNR', value: 'pnr', align: 'start' },
        { text: 'Havayolu Adı', value: 'flightNo' },
        { text: 'Kalkış-Varış', value: 'flightInfo' },
        { text: 'Sipariş Durumu', value: 'orderStatus' },
        { text: 'Yolcu Sayısı', value: 'passengerCount' },
        { text: 'Oluşturulma Tarihi', value: 'creationTime' }
      ]),
      (this.headersPassangers = [
      { text: "", value: "select" },
        { text: "Uçuş", value: "flight" },
        { text: "Uçuş Sınıfı", value: "flightClass" },
        { text: "İsim", value: "name" },
        { text: "Yolcu Türü", value: "passangerType" },
        { text: "Cinsiyet", value: "gender" },
        { text: "Doğum Günü", value: "birthday" },
        { text: "Pasaport", value: "passport" },
        { text: "Pasaport Geçerlilik Tarihi", value: "validityDate" },
        { text: "Fiyat", value: "price" },
      ]);
  }

  async confirmReservation () {
   
    this.orderId=this.reservationList[0].orderId;
    await this.$store
      .dispatch({
        type: "reservation/approveOrderById",
        data: this.orderId,
       
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogConfirm = false;
          this.dialog = false;
          this.$emit("closed");
        }
      });


  }

  async sendTicketEmail() {
    let object: any = {};
    object.orderId = this.reservationList[0].orderId;
    object.emails = [this.reservationList[0].customer.email];
         
          this.closeDialog();
    await this.$store
      .dispatch({
        type: "reservation/sendTicketEmail",
        data: object,
      })
      .then((res) => {
        if (res.status === 200) {

          Vue.$toast.success("E-mail Gönderildi");
        }
      });
  }
  async updateCustomerInfo(){
    var customer = new Customer(); 
    customer.name=this.reservationList[0].customer.name;
    customer.surname=this.reservationList[0].customer.surname;
    customer.email=this.reservationList[0].customer.email;
    customer.gsm=this.reservationList[0].customer.gsm;
    customer.orderId=this.reservationList[0].orderId;
    await this.$store
      .dispatch({
        type: "customer/updateCustomerInformation",
        data: customer,
      })
      .then((res) => {
        if (res.status === 200) {

          Vue.$toast.success("Müşteri Bilgileri Güncellendi");
        }
      });
  }
  async updateBookingPayment(){
    let item ={"orderId":this.orderId,"totalPrice":this.amount,"currencyId":this.currency.id}
   
    await this.$store
      .dispatch({
        type: "reservation/updateBookingPayment",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success("Rezervasyon Para Birimi Değişti");
            this.dialogChangeCurrency=false;
        }
        
      });
  }
  async saveRefund(paymentRule:number){
    var message="";
    let item = new Refund();
    item.orderId=this.reservationList[0].orderId;
    item.paymentRule=paymentRule;
    item.passengers=this.selectedPassengers;
    if(paymentRule==0){
      item.total=this.refundTotal;
      message="Kısmi İade Gerçekleşti.";
    }
    else{
      item.total=this.extraTotal;
      message="Tutar Ekleme Gerçekleşti.";
    }
   
    
    
    

    await this.$store
      .dispatch({
        type: "reservation/saveRefund",
        data: item,
      }).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success(message);

        }
        
      });
      this.dialogRefund=false;
      this.dialogAmount=false;
    this.getOrderDetail(item.orderId);
    
  
    }
  async sendTicketEmailForOperation() {
    let object: any = {};
    object.orderId = this.reservationList[0].orderId;
    object.emails = [this.reservationList[0].customer.email];

          this.closeDialog();
    await this.$store
      .dispatch({
        type: "reservation/sendTicketEmailForOperation",
        data: object,
      })
      .then((res) => {
        if (res.status === 200) {
          
          Vue.$toast.success("Operasyon Satış Maili Gönderildi");
        }
      });
  }
  async cancelReservation() {
    const array = [
      {
        orderId: this.reservationList[0].orderId,
        isOutOfProviderQuota: false,
        isOutOfQuota: false,
        flightOrderRefundRequests: [
          {
            orderId: this.reservationList[0].orderId,
            refundTo: 1,
            total: this.reservationList[0].totalPrice,
            currencyId: this.reservationList[0].currencyId,
          },
        ],
      },
    ];
    this.cancelOrder.orders = array;

    await this.$store
      .dispatch({
        type: "reservation/cancelOrder",
        data: this.cancelOrder,
      })
      .then((res) => {
        if (res.status === 200) {
          this.dialogAgree = false;
          this.dialog = false;
          this.$emit("closed");
        }
      });
  }

  async revertCancellation() {
    try {
      const orderId = this.reservationList[0].orderId;
      await ajax.post('/api/services/app/Admin/RevertCancellation', { orderId });

      Vue.$toast.success("İptal işlemi geri alındı");
      this.dialogRevert = false;
      this.dialog = false;
      this.$emit("closed");
    } catch (error) {
      Vue.$toast.error("İşlem sırasında bir hata oluştu");
      this.dialogRevert = false;
    }
  }

  data() {
    return {
      items: [
        { title: "Sipariş Ödeme" },
        { title: "İptal" },
        { title: "Gri Ödemeler" },
      ],
    };
  }

    async  pdfUrl(){
  
     var response= await this.$store
      .dispatch({
        type: "reservation/pdfLink",
        data: this.reservationList[0].orderId,
      })
      this.pdfLink = response;
     
  }

  selectPassenger(passenger:any){
    this.selectedPassengers = this.reservationList[0].passengers.filter(x=>x.isChecked);
    console.log("data",this.selectedPassengers);

  }

  async cancelPassengers(){
    var response = await ajax.post(
        '/api/services/app/Booking/CancelOrderPassengers',this.selectedPassengers
      ).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success("Yolcu İptali Gerçekleşti");
            this.PassengerCancelModal=false;
        }

      });
      await this.getOrderDetail(this.reservationList[0].orderId );
  }

  async refundPassengers(){
    var response = await ajax.post(
        '/api/services/app/Booking/RefundOrderPassengers',this.selectedPassengers
      ).then((res) => {
        if (res.status === 200) {
            Vue.$toast.success("Yolcu İadesi Gerçekleşti");
            this.PassengerCancelModal=false;
        }

      });
      await this.getOrderDetail(this.reservationList[0].orderId );
  }

  get getPassengers() {
    return this.radioGroup === 1
      ? this.reservationList[0].passengers
      : this.reservationList[1].passengers;
  }

  get pnrAndFlightNo() {
    return this.radioGroup === 1
      ? `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`
      : `${this.reservationList[0].pnr} - ${this.reservationList[0].flightNo}`;
  }

  closeDialog() {
    this.$emit("closed");
  }

  @Watch("dialog")
  onDialogChanged(val: boolean) {
    if (!val) {
      // Emit close so parent unmounts when user presses ESC or clicks outside
      this.closeDialog();
    }
  }

  openRow() {
    this.isOpenRow = true;
  }
  closeRow() {
    this.isOpenRow = false;
  }

  openFlightOrder() {
    this.isOpenFlightOrder = true;
  }
  closeFlightOrder() {
    this.isOpenFlightOrder = false;
  }

  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  openCancelFlightOrderModal() {
    this.isOpenCancelFlightOrderModal = true;
  }
  closeCancelFlightOrderModal() {
    this.isOpenCancelFlightOrderModal = false;
  }

  openPassengerEditModal() {
    this.isOpenPassengerEditModal = true;
  }
  closePassengerEditModal() {
    this.isOpenPassengerEditModal = false;
  }

  openRemovePassengerModal() {
    this.isOpenRemovePassengerModal = true;
  }
  closeRemovePassengerModal() {
    this.isOpenRemovePassengerModal = false;
  }

  openEmailList() {
    this.isOpenEmailList = true;
  }
  closeEmailList() {
    this.isOpenEmailList = false;
  }
  openAddList() {
    this.isOpenAddList = true;
  }
  closeAddList() {
    this.isOpenAddList = false;
  }
  openServiceLogs() {
    this.isOpenServiceLogs = true;
  }
  closeServiceLogs() {
    this.isOpenServiceLogs = false;
  }
  get phoneNumber(){
     return  "+"+this.reservationList[0].customer.gsm 
  }
  formatDate(date) {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getFullYear()}`;
  }
}
